let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l227z")).then(() => parcelRequire('fWN8v'));